module.exports = __webpack_public_path__ + "static/media/icon-timeline.513ff242.svg";